<template>
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 16.8174 18.0784 20.7756 13.4625 21.4781V14.8617H16.2563L16.6945 12.0234H13.4625V10.4719C13.4625 9.29227 13.8468 8.24531 14.9508 8.24531H16.7227V5.76797C16.4107 5.72597 15.7522 5.63438 14.5078 5.63438C11.9086 5.63438 10.3852 7.00717 10.3852 10.1344V12.0234H7.71328V14.8617H10.3852V21.4547C5.84435 20.689 2.4 16.7643 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4Z"
        />
    </svg>
</template>
